export const FETCH_ALLOWANCES = "FETCH_ALLOWANCES";
export const FETCH_ALLOWANCES_SUCCESS = "FETCH_ALLOWANCES_SUCCESS";
export const FETCH_ALLOWANCES_FAILURE = "FETCH_ALLOWANCES_FAILURE";

export const CREATE_ALLOWANCE_REQUEST = "CREATE_ALLOWANCE_REQUEST";
export const CREATE_ALLOWANCE_SUCCESS = "CREATE_ALLOWANCE_SUCCESS";
export const CREATE_ALLOWANCE_FAILURE = "CREATE_ALLOWANCE_FAILURE";

export const DELETE_ALLOWANCE = "DELETE_ALLOWANCE";
export const DELETE_ALLOWANCE_SUCCESS = "DELETE_ALLOWANCE_SUCCESS";
export const DELETE_ALLOWANCE_FAILURE = "DELETE_ALLOWANCE_FAILURE";
